import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import { ChapterLabel, Reveal } from "@/components/landing/Reveal";
import { FAQ_ITEMS } from "@/lib/site";

const Faq = () => (
    <section
        id="faq"
        data-testid="faq-section"
        className="border-y border-white/10 bg-[#0A0A0A]"
    >
        <div className="mx-auto max-w-4xl px-5 py-24 md:px-10 md:py-36">
            <Reveal>
                <ChapterLabel number="Nº 08" title="Questions" testId="faq-label" />
            </Reveal>
            <Reveal delay={0.1}>
                <h2 className="mt-8 font-serif text-3xl font-medium leading-tight tracking-tight text-ivory md:text-5xl">
                    EVERYTHING,{" "}
                    <span className="italic text-gold">ANSWERED.</span>
                </h2>
            </Reveal>

            <Reveal delay={0.15}>
                <Accordion
                    type="single"
                    collapsible
                    className="mt-14"
                    data-testid="faq-accordion"
                >
                    {FAQ_ITEMS.map((item, i) => (
                        <AccordionItem
                            key={item.q}
                            value={`item-${i}`}
                            className="border-white/10"
                        >
                            <AccordionTrigger
                                data-testid={`faq-question-${i}`}
                                className="py-6 text-left text-sm font-semibold tracking-wide text-ivory transition-colors duration-300 hover:text-gold hover:no-underline md:text-base"
                            >
                                {item.q}
                            </AccordionTrigger>
                            <AccordionContent
                                data-testid={`faq-answer-${i}`}
                                className="pb-6 text-sm leading-relaxed text-muted"
                            >
                                {item.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </Reveal>
        </div>
    </section>
);

export default Faq;
